(function () {
  // Guard: only initialise once per page even if the snippet renders multiple times
  if (window.__whProgress) return;
  window.__whProgress = true;

  var CART_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var baseCartQty = 0;

  // ── helpers ───────────────────────────────────────────────────────────────

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof Request) return input.url;
    return (input && input.url) ? input.url : '';
  }

  function isCartMutation(url) {
    return CART_PATHS.some(function (p) { return url.indexOf(p) !== -1; });
  }

  // ── core render ───────────────────────────────────────────────────────────

  function renderBar(bar, qty) {
    var wsQty      = parseInt(bar.dataset.t1Qty, 10)      || 5;
    var wsDiscount = parseInt(bar.dataset.t1Discount, 10) || 10;

    var msg  = bar.querySelector('.wholesale-progress__message');
    var fill = bar.querySelector('.wholesale-progress__fill');
    var lbl  = bar.querySelector('[data-tier="1"]');
    if (!msg || !fill) return;

    var fillPct = Math.min((qty / wsQty) * 100, 100);

    // Inline style via setAttribute to avoid any external override
    fill.setAttribute('style',
      'width:' + fillPct + '%;' +
      'transition:width 0.45s ease;' +
      'height:100%;' +
      'border-radius:3px;' +
      'background:' + (fillPct >= 100 ? 'linear-gradient(90deg,#8d5f4a,#c4956a)' : 'linear-gradient(90deg,#8d5f4a,#b8886f)')
    );

    msg.classList.remove('wholesale-progress__message--unlocked');
    if (lbl) lbl.classList.remove('wholesale-progress__tier-label--active');

    if (qty >= wsQty) {
      msg.classList.add('wholesale-progress__message--unlocked');
      msg.textContent = wsDiscount + '% wholesale discount applied!';
      if (lbl) lbl.classList.add('wholesale-progress__tier-label--active');
    } else {
      var needed = wsQty - qty;
      msg.textContent = 'Add ' + needed + ' more item' + (needed === 1 ? '' : 's') +
        ' to unlock ' + wsDiscount + '% wholesale pricing';
    }
  }

  function renderAll(qty) {
    document.querySelectorAll('.wholesale-progress').forEach(function (bar) {
      renderBar(bar, qty);
    });
  }

  // ── cart sync ─────────────────────────────────────────────────────────────

  function syncCart(callback) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        baseCartQty = cart.item_count;
        if (callback) callback();
        else renderAll(baseCartQty);
      })
      .catch(function () {});
  }

  // ── quantity preview on product pages ─────────────────────────────────────

  function previewQty() {
    var qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    var inputQty = Math.max(parseInt(qtyInput.value, 10) || 1, 0);
    renderAll(baseCartQty + inputQty);
  }

  function watchQtyInput() {
    var qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput || qtyInput._whWatched) return;
    qtyInput._whWatched = true;
    ['input', 'change'].forEach(function (evt) {
      qtyInput.addEventListener(evt, previewQty);
    });
  }

  // ── intercept cart mutations ──────────────────────────────────────────────

  // After a cart mutation Dawn re-renders sections (replacing DOM nodes).
  // We sync twice: once fast (update text) and once after Dawn finishes re-rendering.
  function renderNow() {
    renderAll(baseCartQty);
    watchQtyInput();
    previewQty();
  }

  function onCartMutation() {
    setTimeout(function () { syncCart(renderNow); }, 80);
    setTimeout(function () { syncCart(renderNow); }, 600);
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var result = origFetch.call(this, input, init);
    if (isCartMutation(getUrl(input))) {
      result.then(onCartMutation).catch(function () {});
    }
    return result;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && isCartMutation(url)) {
      this.addEventListener('load', onCartMutation);
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('cart:refresh', onCartMutation);
  document.addEventListener('cart:updated', onCartMutation);

  // ── boot ──────────────────────────────────────────────────────────────────

  syncCart(renderNow);
})();
